// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1b5Wr","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1ir5B","obliqueLine":"membershipbadge_obliqueLine__3IdxO"};